import {
  ReactNode,
  createContext,
  memo,
  useContext,
  useEffect,
  useState,
} from "react";
import type { Auth } from "./auth";
import { teamAuthStore } from "./auth";

export const AuthContext = createContext<Auth | undefined>(undefined);

export type SetAuth = (auth: Auth | undefined) => void;

export const SetAuthContext = createContext<SetAuth | undefined>(undefined);

export function useAuth(): Auth | undefined {
  return useContext(AuthContext);
}

interface AuthProviderProps {
  children: ReactNode;
  initialAuth: Auth | undefined;
}

export const AuthProvider = memo(function AuthProvider({
  children,
  initialAuth,
}: AuthProviderProps) {
  const [auth, setAuth] = useState(initialAuth);

  useEffect(() => {
    if (!auth) {
      return;
    }

    teamAuthStore(auth.teamId).set(auth.token);

    const duration = auth.expiration.since(Temporal.Now.instant());
    const timeout = setTimeout(
      () => setAuth(undefined),
      Math.min(2_147_483_647, duration.total("milliseconds")),
    );
    return () => clearTimeout(timeout);
  }, [auth]);

  return (
    <AuthContext.Provider value={auth}>
      <SetAuthContext.Provider value={setAuth}>
        {children}
      </SetAuthContext.Provider>
    </AuthContext.Provider>
  );
});
